import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment mainFileUploadsAsset on Craft_mainFileUploads_Asset {
    uid
    url
    title
    extension
    height
    width
    altTag
    localFile {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, formats: [AUTO])
      }
    }
  }

  fragment cardPictureAsset on Craft_mainFileUploads_Asset {
    uid
    url
    title
    extension
    height
    width
    altTag
    localFile {
      childImageSharp {
        gatsbyImageData(
          width: 763
          height: 723
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`

export const mainFileUploadsAssets = gql`
  fragment mainFileUploadsAsset on mainFileUploads_Asset {
    uid
    url
    title
    extension
    height
    width
    altTag
  }

  fragment cardPictureAsset on mainFileUploads_Asset {
    uid
    url
    title
    extension
    height
    width
    altTag
  }
`
